import React from 'react';
import styled from 'styled-components';

// Component
import LiveArea from '../../components/Layout/LiveArea';
import ContainerO from '../../components/Layout/Container/ContainerO';
import BttHuge from '../../components/Buttons/ButtonLink/BttHuge';

import img1 from '../../assets/img/ill/AboutCompetition/01.png';
import img2 from '../../assets/img/ill/AboutCompetition/02.png';
import img3 from '../../assets/img/ill/AboutCompetition/03.png';
import img4 from '../../assets/img/ill/AboutCompetition/04.png';

// Context
import { useEssayListState } from '../../context/essayListContext';


const Container = styled(LiveArea)`
  display: flex;
  flex-direction: column;
  margin-bottom: 100px;
  @media screen and (max-width: 480px) {
    padding:0 20px;
    margin-bottom: 144px;
  }
`

const Title = styled.p`
  width: 100%;
  text-align: center;
  margin-bottom: 20px;
  font-family: ${props => props.theme.type.bold};
  ${props => props.theme.type.h3};
  color: ${props => props.theme.color.brand.primary700};
`;

const SubTitle = styled.p`
  position: absolute;
  top: 0;
  left: 0;
  font-family: ${props => props.theme.type.bold};
  ${props => props.theme.type.h5};
  color: ${props => props.theme.color.brand.primary700};
  @media screen and (max-width: 480px) {
      /* margin-top: 20px; */
      position: static;
      height: 108px;
      width: 100%;
  }
`;

const Btt = styled(BttHuge)`
  width: 600px;
  margin-bottom: 40px;
  @media screen and (max-width: 480px) {
    width: 240px;
  }
`;

const Section = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 500px;
  margin-bottom: 20px;
  border-bottom: solid 1px ${props => props.theme.color.brand.primary300};
  img{
    width: 500px;
    height: 460px;
  }
  img.cat{
    width: 500px;
    height: 340px;
  }
  @media screen and (max-width: 480px) { 
    img{
      width: calc(100% - 40px) !important;
      height: auto !important;
    }   
    height: auto;
  }
`;

function AboutBrandedPresent (){
  const {  essayListContextData } = useEssayListState();
  console.log(essayListContextData.brandedList);
  let length = essayListContextData.brandedList.length;
  let list = essayListContextData.brandedList;
  let lastBrandedId = list[length-1]._id;
  return(
    <Container className={'router_area_top'}>
      <Title>
        ‘우리가 사랑하는 것들'이 무엇인가요?
      </Title>
      <ContainerO>
        <Section>
          <SubTitle>
          생각만 해도 기분이 좋아지는 것들,<br/>삶의 위안을 주는 것들에 대한 기억과 생각들을<br/>정리하는 에세이를 써보는 코너입니다
          </SubTitle>
          {/* <img src={img1} alt={''} /> */}
        </Section>
        <Section>
          <SubTitle>
          기호품과 서비스,때로는 브랜드가<br/>자신에게 어떤 의미를 가지는지에 대해<br/>써보고 함께 이야기를 나누어 봅니다. 
          </SubTitle>
          {/* <img src={img2} alt={''} /> */}
        </Section>
        <Section>
          <SubTitle>
          그럼 ‘우사것' 구경하러 가볼까요?
          </SubTitle>
          {/* <img src={img3} alt={''} /> */}
          <Btt
            type={'filled_primary'}
            title={'우사것 구경가기'}
            to={`/branded/${lastBrandedId}`}
          />
        </Section>
      </ContainerO>
    </Container>
    )
}

export default AboutBrandedPresent;